(ns rothko.theme.manatee.editor.word
  (:require [garden.color :refer [lighten rgb rgba]]
            [rothko.theme.manatee.editor.common :as common-theme]))

(def main
  (merge
   common-theme/different
   {:edited
    {:color (rgb 210 91 71)
     :text-decoration :line-through 
     :display :inline-block}

    :hover
    {:outline "1px dotted grey"}

    :focussed
    {:outline "2px solid green"}

    :ignored
    {:color (rgb 169 169 169)
     :background-color (rgba 211 211 211 0.4)}

    :misspelled
    {:text-decoration :underline
     :text-decoration-color (rgb 180 0 0)
     :text-decoration-style :wavy}

    :system-annotation
    {:background-color (rgb 255 255 210)}

    :suspicious
    {:background-color (rgb 255 238 238)}}))
